<template>
  <div id="app">
    <router-view />
    <Toast position="bottom-center" />
    <ConfirmDialog />
  </div>
</template>

<script setup>
import Toast from 'primevue/toast'
import ConfirmDialog from 'primevue/confirmdialog'
</script>

<style lang="scss">
@use 'sass:color';
@use '@/theme.scss' as *;
@import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@400;700&display=swap');
@import 'bulma/css/bulma.css';

// Theme-scoped custom properties. Light mode inherits Bulma's defaults;
// dark mode overrides to a softer palette (medium charcoal background,
// dimmed navbar, signature pad with enough contrast to see dark ink).
:root {
  --app-bg: var(--bulma-scheme-main, #fff);
  --navbar-bg: #{$primary};
  --sig-bg: #ffffff;

  // Admin shell (sidebar + cards). Light mode keeps the original look;
  // dark mode drops to a slightly darker panel than the page so the
  // sidebar still reads as a distinct rail.
  --panel-bg: #f5f7fa;
  --panel-border: #e2e6ea;
  --panel-hover-bg: #e2e6ea;
  --panel-text: #333;
  --muted-text: #555;
}

:root[data-theme='dark'] {
  --app-bg: #333333;
  --navbar-bg: #{color.adjust($primary, $lightness: -22%)};
  --sig-bg: #bfbfbf;

  --panel-bg: #262626;
  --panel-border: #444;
  --panel-hover-bg: #3a3a3a;
  --panel-text: #e5e5e5;
  --muted-text: #b5b5b5;
}

#app {
  font-family: 'Open Sans', sans-serif;
  // Inherit Bulma's --bulma-text (flips with [data-theme]) instead of a fixed
  // dark color so the app is readable in both light and dark themes.
  color: var(--bulma-text, #222);
  background-color: var(--app-bg);
  min-height: 100vh;
}

html,
body {
  background-color: var(--app-bg);
}

iframe {
  width: 640px;
  height: 380px;
}

.p-toast {
  z-index: 9999;
}

a {
  color: $primary;
}

// Bring Bulma's legacy `is-primary` button etc. in line with our theme
.button.is-primary {
  background-color: $primary;
  border-color: transparent;
  color: #fff;

  &:hover {
    background-color: color.adjust($primary, $lightness: -5%);
  }
}
</style>
